(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["new_to_linen_video_grid"] && !Shopify.designMode) return;
  try {
    // Keeps the "New to linen?" videos from playing forever:
  // - Each video pauses whenever it scrolls out of view, and resumes when
  //   it scrolls back in (saves battery/data for anyone not looking at it).
  // - Once the group first comes into view, a single shared timer starts.
  //   When it fires, all three videos pause TOGETHER (regardless of each
  //   one's own length/loop position) and each shows its own play button.
  // - Tapping a play button resumes only that video, and restarts the same
  //   auto-stop timer for it — so it plays for the configured duration again,
  //   then pauses and shows its play button again (rinse and repeat), rather
  //   than looping forever after the first resume.
  // - The video itself is also clickable at any time, on top of all the
  //   above: clicking a playing video pauses it (and cancels its pending
  //   auto-stop timer); clicking a paused one resumes it — same toggle the
  //   "Play again" label uses.
  // The pause duration is read from a data attribute so it stays
  // configurable per-block via the schema setting, without needing Liquid
  // inside this tag (this file is bundled once and shared across every
  // instance of the block on the page).
  (function () {
    if (window.__linenIntroVideoInit) return;
    window.__linenIntroVideoInit = true;

    function initGroup(row) {
      if (row.dataset.linenIntroInit) return;
      row.dataset.linenIntroInit = '1';

      var pauseAfterMs = (parseInt(row.getAttribute('data-auto-pause-seconds'), 10) || 10) * 1000;
      var entries = Array.prototype.map.call(
        row.querySelectorAll('.linen-intro-wrapper-js'),
        function (wrapper) {
          return { wrapper: wrapper, video: wrapper.querySelector('video'), stopped: false, resumeTimer: null };
        }
      ).filter(function (e) { return e.video; });

      var timerStarted = false;

      function stopOne(e) {
        e.stopped = true;
        if (e.resumeTimer) {
          clearTimeout(e.resumeTimer);
          e.resumeTimer = null;
        }
        e.video.pause();
        e.wrapper.classList.add('linen-intro__media-wrapper--paused');
      }

      function stopAll() {
        entries.forEach(stopOne);
      }

      function resumeOne(e) {
        e.stopped = false;
        e.wrapper.classList.remove('linen-intro__media-wrapper--paused');
        e.video.play().catch(function () {});
        if (e.resumeTimer) {
          clearTimeout(e.resumeTimer);
        }
        e.resumeTimer = setTimeout(function () { stopOne(e); }, pauseAfterMs);
      }

      function togglePlayback(e) {
        if (e.stopped) {
          resumeOne(e);
        } else {
          stopOne(e);
        }
      }

      function startTimer() {
        if (timerStarted) return;
        timerStarted = true;
        setTimeout(stopAll, pauseAfterMs);
      }

      entries.forEach(function (e) {
        e.video.loop = true;
        e.video.muted = true;

        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(
            function (obsEntries) {
              obsEntries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  startTimer();
                  if (!e.stopped) {
                    e.video.play().catch(function () {});
                  }
                } else {
                  e.video.pause();
                }
              });
            },
            { threshold: 0.25 }
          );
          observer.observe(e.video);
        }

        e.video.addEventListener('click', function () {
          togglePlayback(e);
        });

        var btn = e.wrapper.querySelector('.linen-intro__play-btn-js');
        if (btn) {
          btn.addEventListener('click', function (evt) {
            evt.stopPropagation();
            togglePlayback(e);
          });
        }
      });
    }

    function scan() {
      document.querySelectorAll('.linen-intro-media-row-js').forEach(initGroup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
